import { render, staticRenderFns } from "./GoogleLoginServer.vue?vue&type=template&id=2f658e80&scoped=true&"
import script from "./GoogleLoginServer.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginServer.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLoginServer.vue?vue&type=style&index=0&id=2f658e80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f658e80",
  null
  
)

export default component.exports